import {apiGet, apiPost} from './client';

export function getVoices() {
    return apiGet('/celebs/skazki/voices');
}

export function getTale(taleId) {
    return apiGet(`/celebs/skazki/${taleId}`);
}

export function listTales(accountId) {
    return apiGet(`/celebs/skazki/list?account_id=${encodeURIComponent(accountId)}`);
}

export function commitTale(taleId, {voice} = {}) {
    return apiPost(`/celebs/skazki/${taleId}/commit`, voice ? {voice} : {});
}

// Generate the preview text for a tale and return the persisted tale in full.
// The preview is short, so it's a plain request/response — no streaming.
export function generateTaleText(payload) {
    return apiPost('/celebs/skazki/generate-text', {
        tale_id: payload.taleId || null,
        account_id: payload.accountId,
        child_name: payload.childName,
        age: payload.age,
        interests: payload.interests || [],
        genre: payload.genre,
        voice: payload.voice,
        tempo: payload.tempo || 'normal',
        moral: payload.moral || null,
        music: payload.music || null,
        language: payload.language || 'ru',
        instruction: payload.instruction || null,
    });
}
